import { Dimensions, Platform } from "react-native";
import StyleSheet from "react-native-media-query";

const { ids, styles } = StyleSheet.create({
  errorView: {
    zIndex: 990,
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
  },
  inMiddle: {
    display: "flex",
    alignItems: "center",
  },
  bgEffectBottom: {
    backgroundColor: "rgba(255,255,255,.1)",
    position: "absolute",
    bottom: -227,
    right: -101,
    transform: [{ rotate: "45deg" }],
    width: 400,
    height: 800,
    zIndex: -1,
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          bottom: -472,
          right: -101,
          display: "flex",
        },
        "@media (min-width: 700px)": {
          bottom: -472,
          right: -101,
          display: "flex",
        },
        "@media (min-width: 1150px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1281px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1441px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1681px)": {
          bottom: -472,
          right: -101,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          bottom: -472,
          right: -101,
          display: "flex",
        },
        "@media (min-width: 700px)": {
          bottom: -472,
          right: -101,
          display: "flex",
        },
        "@media (min-width: 1150px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1281px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1441px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1681px)": {
          bottom: -472,
          right: -101,
        },
      },
      web: {
        zIndex: -1,
        "@media (min-width: 200px)": {
          display: "none",
        },
        "@media (min-width: 700px)": {
          bottom: -472,
          right: -101,
          display: "block",
        },
        "@media (min-width: 1150px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1281px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1441px)": {
          bottom: -472,
          right: -101,
        },
        "@media (min-width: 1681px)": {
          bottom: -472,
          right: -101,
        },
      },
    }),
  },
  coverImage: {
    width: "100%",
    ...Platform.select({
      ios: {
        display: "flex",
        flex: 1,
      },
      android: {
        display: "flex",
        flex: 1,
      },
      web: {
        overflow: "hidden",
        // position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        flex: 1,
        // height: Dimensions.get('window').height,
      },
    }),
  },
  bgEffect: {
    backgroundColor: "rgba(255,255,255,.1)",
    position: "absolute",
    "@media (min-width: 700px)": {
      top: -272,
      left: -101,
    },
    top: -527,
    left: -101,
    transform: [{ rotate: "45deg" }],
    width: 400,
    height: 800,
  },
  rowFlex: {
    display: "flex",
    flexDirection: "row",
  },
  rowFlexAlignCenter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  colFlex: {
    display: "flex",
    flexDirection: "column",
  },
});

export default {
  ids,
  styles,
};
